// extracted by mini-css-extract-plugin
export var avatarContainer = "_52-0";
export var avatarTypingWave = "_52-i";
export var gray = "_52-f";
export var green = "_52-c";
export var icon = "_52-9";
export var image = "_52-1";
export var lg = "_52-6";
export var md = "_52-5";
export var presenceDot = "_52-b";
export var red = "_52-d";
export var sm = "_52-4";
export var status = "_52-a";
export var typingDot = "_52-h";
export var typingPill = "_52-g";
export var xl = "_52-7";
export var xs = "_52-3";
export var xxl = "_52-8";
export var xxs = "_52-2";
export var yellow = "_52-e";